import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function initEventCardsComponent() {
    const sections = document.querySelectorAll('.event-cards-section');

    sections.forEach((section) => {
        const sliderEl = section.querySelector('.ecc-slider-wrapper');
        if (!sliderEl) {
            return;
        }

        const prevBtn = section.querySelector('.ecc-button-prev');
        const nextBtn = section.querySelector('.ecc-button-next');
        const paginationEl = section.querySelector('.ecc-pagination');

        let swiperInstance = null;

        function initSwiper() {
            if (swiperInstance) {
                return;
            }

            const SwiperClass = typeof Swiper !== 'undefined' ? Swiper : window.Swiper;
            if (!SwiperClass) {
                return;
            }

            swiperInstance = new SwiperClass(sliderEl, {
                slidesPerView: 2,
                spaceBetween: 32,
                speed: 500,
                autoHeight: false,
                navigation: prevBtn && nextBtn ? {
                    prevEl: prevBtn,
                    nextEl: nextBtn,
                } : false,
                pagination: paginationEl ? {
                    el: paginationEl,
                    clickable: true,
                } : false,
            });
        }

        function destroySwiper() {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        }

        function handleSwiper() {
            const isDesktop = window.innerWidth >= 768;

            if (isDesktop) {
                initSwiper();
            } else {
                destroySwiper();
            }
        }

        handleSwiper();
        window.addEventListener('resize', handleSwiper);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEventCardsComponent);
} else {
    initEventCardsComponent();
}
